module.exports = __webpack_public_path__ + "img/26.4e4330e3.jpg";